/**
 * "You are editing France" — stated once, above the conditions.
 * For Media Devoted | Created By Ciro Autiero
 *
 * The scope used to be squeezed into the value column's label, where it
 * truncated to "Value for Fra…" and pushed the hint into three wrapped lines.
 * One banner says it once, in full, and gives the columns their width back.
 */

import type { FC } from 'react';
import { Pencil } from 'lucide-react';

import type { ScopeLabel } from '@/features/tag-rule-scope';

export const ScopeBanner: FC<{ label: ScopeLabel }> = ({ label }) => {
  const where = label.campaign ?? label.country;
  return (
    <div className="mb-2 space-y-1 rounded-md border border-primary/30 bg-primary/5 px-3 py-2 text-xs">
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <Pencil className="h-3.5 w-3.5 shrink-0 text-primary" aria-hidden />
        <span className="text-muted-foreground">Numbers below apply to</span>
        <span className="font-semibold text-foreground">
          {label.icon} {label.country}
        </span>
        {label.campaign ? (
          <>
            <span className="text-muted-foreground">›</span>
            <span className="font-semibold text-foreground">{label.campaign}</span>
          </>
        ) : null}
        <span className="rounded bg-primary/15 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-primary">
          {label.campaign ? 'campaign' : 'country'} only
        </span>
      </div>
      {/* The question this banner exists to answer: the modal shows the RULE
          (shared by everyone) and one scoped NUMBER side by side, and nothing
          else distinguishes them. */}
      <p className="text-muted-foreground">
        The rule itself — its name, colour, metrics and date range — is shared by
        every campaign. Only the <strong className="font-semibold">values</strong> you
        type here belong to {where}.
      </p>
    </div>
  );
};
